var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectOnlineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1057_3163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8983 11.7944H21.407V37.1641H41.8983V11.7944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1835 10.6084C19.3782 10.6084 18.7292 11.2435 18.7292 12.0305V36.0172C18.7292 36.8041 19.3782 37.4393 20.1835 37.4393H40.9441C41.7495 37.4393 42.3984 36.8041 42.3984 36.0172V12.0305C42.3984 11.2435 41.7495 10.6084 40.9441 10.6084H20.1835ZM19.8921 11.7866H41.2233V36.2473H19.8921V11.7866Z",
    fill: "#30742E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3298 28.6331L29.6363 32.9395C29.7258 33.029 29.8471 33.0792 29.9736 33.0792C30.1002 33.0792 30.2215 33.029 30.311 32.9395L34.6174 28.6331L30.311 24.3266C30.2215 24.2372 30.1002 24.1869 29.9736 24.1869C29.8471 24.1869 29.7258 24.2372 29.6363 24.3266L25.3298 28.6331Z",
    fill: "#30742E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6642 16.6146V22.0698H32.107C31.9587 22.0698 31.8177 22.2595 31.9751 22.4314L35.6598 26.1412L39.2865 22.4233C39.4 22.307 39.3435 22.0698 39.1458 22.0698H36.5465V15.2861C36.5175 15.0543 36.3349 14.8718 36.1031 14.8428H26.1348V16.6146H34.6642Z",
    fill: "#30742E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8913 41.2043V7.2002L6.39917 10.5997V37.8033L26.8913 41.2043Z",
    fill: "url(#paint0_linear_1057_3163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2263 29.725V18.3314L17.1704 18.1121C18.447 18.0709 19.042 18.5039 19.6311 19.3461C20.145 20.0824 20.2984 21.1418 20.2186 22.0684C20.0483 24.0259 18.8379 25.7164 17.017 25.8085H15.3556V23.7041H16.4632C17.257 23.6689 17.8522 22.8034 17.8142 21.9044C17.7801 20.8904 17.247 20.289 16.5255 20.2636L15.3556 20.2705L15.3571 29.8523L13.2263 29.725Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1057_3163",
    x1: 26.8909,
    y1: 24.2024,
    x2: 6.39974,
    y2: 24.2024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E6E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#327A30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1057_3163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34.0042,
    fill: "white",
    transform: "translate(6.40039 7.2002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectOnlineIcon);
export default __webpack_public_path__ + "static/media/projectOnline-icon.1c4dfa0d750db40dfec3e06be1e5e6e3.svg";
export { ForwardRef as ReactComponent };